// extracted by mini-css-extract-plugin
export default {"container":"section-page_container__16dxL","filters":"section-page_filters__1uQm4"};